<template>
  <div class="row shopping-cart-checkout">
    <div class="col-md-1"></div>
    <div class="col-md-10">
      <div align="left">
        <h2>{{$t("checkout.title")}}</h2>
      </div>
      <p class="description">
        {{$t("checkout.description")}}
      </p>
      <br/>
      <div class="row" v-for="item in this.shoppingCart.items" v-bind:key="item.id">
        <div class="col-md-2 col-2">
          <img :src="item.preview" class="image-cart" v-if="item.photo_id"/>
          <img src="../../images/full-gallery.png" class="image-cart" v-if="item.photo_id == null"/>
        </div>
        <div class="col-md-7 col-7">
          <p class="item-name">{{item.name}}</p>
          <!--p>Fotos en el album: <b>57</b></p-->
        </div>
        <div class="col-md-3 col-3">
          <div class="row">
            <div class="col-md-12 col-12">
              <p class="item-price">
                <label class="price" :class="{'discount-price': item.discounts}">
                  {{item.price | toCurrency}}
                </label>
                <label v-if="item.discounts">
                  <span
                    v-for="discount in shoppingCart.itemDiscounts(item)"
                    class="badge rounded-pill bg-danger badge-discount">
                    {{discount}}
                  </span>
                </label>
                <label class="price" v-if="item.discounts">
                  {{item.total_price | toCurrency}}
                </label>
              </p>
              <div align="right">
                <button class="delete-item" @click="removeItem(item)">
                  <i class="fas fa-trash-alt icon-trash"></i>
                </button>
              </div>
            </div>
          </div>
        </div>


        <div class="col-12 visually-hidden">
          <div class="row">
            <div class="col-9">
              Para agregar mas fotos al album ingrese su numero de competidor
            </div>
            <div class="col-3">
              <div class="form-group">
                <input type="text" class="form-control" placeholder="Competidor"/>
              </div>
            </div>
          </div>
          <!--div class="quantity buttons_added">
            <div class="quantity-toggle">
              <span class="participants_checkout">{{ $t("checkout.members") }}</span>
              <button class="quantity-left-minus btn btn-number" @click="decrement(item)">
                <i class="fas fa-minus"></i>
              </button>
              <input type="text" :value="quantity" readonly>
              <button class="quantity-right-plus btn btn-number" @click="increment(item)">
                <i class="fas fa-plus"></i>
              </button>
            </div>
          </div-->
        </div>
        <!--div class="col-12 visually-hidden" v-for="participant in item.participants">
          <div class="row">
            <div class="col-8">
              <div class="form-group">
                <input type="text" class="form-control" placeholder="Nombre *"/>
              </div>
            </div>
            <div class="col-4">
              <div class="form-group">
                <input type="text" class="form-control" placeholder="Numero"/>
              </div>
            </div>
          </div>
        </div-->
      </div>

      <div class="row cart-summary cart-amounts" v-if="loaded">
        <hr class="separate_hr">
        <div class="col-md-6"></div>


        <div class="col-md-6">
          <div class="row">
            <div class="col-md-12" v-if="shoppingCart.hasTax()">
              <div class="row">
                <div class="col-sm-9">
                  <p class="total-text">{{$t("checkout.subTotal")}} :</p>
                </div>
                <div class="col-sm-3">
                  <div class="total-amount">
                    {{shoppingCart.summary.sub_total | toCurrency}}
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-9">
                  <p class="total-text">{{shoppingCart.summary.tax_name}} :</p>
                </div>
                <div class="col-sm-3">
                  <div class="total-amount">
                    {{shoppingCart.summary.tax | toCurrency}}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- total -->
          <div class="row">
            <div class="col-sm-9">
              <p class="total-text">{{$t("checkout.total")}} :</p>
            </div>
            <div class="col-sm-3">
              <div class="total-amount">
                {{shoppingCart.total() | toCurrency}}
              </div>
            </div>
          </div>

          <!-- extra discount -->
          <div class="row">
            <hr class="separate_hr"/>
            <div class="col-sm-12" v-if="shoppingCart.hasExtraDiscount()">
              <div class="row">
                <div class="col-sm-9">
                  <p class="total-text">{{$t("checkout.extraDiscount")}} :</p>
                </div>
                <div class="col-sm-3">
                  <div class="total-amount">
                    {{shoppingCart.summary.extra_discount}} %
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-9">
                  <p class="total-text">
                    {{$t("checkout.totalExtraDiscount")}} {{shoppingCart.summary.currency}} :
                  </p>
                </div>
                <div class="col-sm-3">
                  <div class="total-amount">
                    {{shoppingCart.summary.total_order | toCurrency}}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- currency -->
          <div class="row">
            <hr class="separate_hr"/>
            <div class="col-sm-5">
              <p class="convert-currency">{{$t("checkout.converCurrency")}} :</p>
            </div>
            <div class="col-sm-4">
              <select class="form-select input-search" @change="getConvertCurrency"
                v-model="shoppingCart.summary.currency_payment">
                <option v-for="currency in currencies" 
                  v-bind:key="currency.id"
                  :value="currency.code">
                  {{currency.code}}
                </option>
              </select>
            </div>
            <div class="col-sm-3">
              <div class="total-amount">
                {{shoppingCart.summary.currency_total | toCurrency}}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-1"></div>
  </div>
</template>

<script>
import {mapGetters} from "vuex"
import Currency from "../../models/Currency"
import ShoppingCart from "../../models/ShoppingCart"

export default {
  name: "SummaryCheckout",
  data() {
    return {
      shoppingCart: new ShoppingCart(),
      currencies: [],
      quantity: 1,
      loaded: false,
      currency: '',
      apiKey: 'b0f17da1ee-46f0420ba5-rnzd5c'
    }
  },
  props: {
    loadingSummary: Function
  },
  async created() {
    const currency = new Currency();
    this.currencies = await currency.fetch();
    await this.fetch();
    this.$root.$on("recoverCard", this.recoverCard);
    this.currency = this.currentPreference.currency;
  },
  methods: {
    async fetch() {
      this.loaded = false
      const cart = await this.shoppingCart.fetch()

      this.shoppingCart.items = cart.items
      this.shoppingCart.summary = cart.summary

      this.$root.$emit("setShopingCart", this.shoppingCart)
      this.loaded = true
      this.loadingSummary(false)
    },
    async recoverCard() {
      await this.fetch()
    },
    async removeItem(item) {
      await this.loadingSummary(true)
      await this.shoppingCart.removeItem(item.id)
      this.$root.$emit("addItemToCart", '')
      await this.fetch()
    },
    async getConvertCurrency() {
      try {
        this.loadingSummary(true)
        const toCurrency = this.shoppingCart.summary.currency_payment;
        const amount = this.shoppingCart.summary.total_order;

        const response = await this.$http.get(
          `https://api.fastforex.io/convert?api_key=${this.apiKey}&from=${this.currency}&to=${toCurrency}&amount=${amount}`,
        )

        if(response && response.status === 200) {
          this.shoppingCart.summary.currency_total = response.data.result[toCurrency];
          this.$root.$emit("setShopingCart", this.shoppingCart)
        }
      } catch (e) {
        console.log(e)
      } finally {
        this.loadingSummary(false)
      }
    },
    increment(item) {
      this.quantity++
      item.participants.push({name: "", number: ""})
    },
    decrement(item) {
      if (this.quantity > 1) {
        item.participants.pop()
        this.quantity--
      }
    }
  },
  computed: {
    ...mapGetters('Preference', ['currentPreference']),
  }
}
</script>

<style lang="scss">
  @import '../../scss/variables.scss';

  .delete-item {
    background: #FFFFFF;
    border-radius: 40px;
    text-align: center;
    width: 40px;
    height: 40px;
    box-shadow: 5px -3px 15px -3px #000000;
    line-height: 45px;
    cursor: pointer;
  }

  .discount-price {
    text-decoration: line-through;
    color: red;
    padding-right: 10px;
  }

  .shopping-cart-checkout {
    .total-text, .total-amount {
      text-align: right;
      font-weight: bolder;
      margin-bottom: 0;
    }

    .total-text {
      font-size: 16px;
    }

    .total-amount {
      font-size: 17px;
      padding-right: 10px;
    }
  }

  .cart-amounts {
    .row + .row {
      margin-top: 0px !important;
    }

    p.convert-currency {
      line-height: 30px;
    }
  }

  @media (max-width: 550px) {
    .buttons_added {
      margin-top: 100px;
    }
  }
</style>
